export default "__VITE_ASSET__DUxFCk_g__"